import { transformAppDetails } from '../GetDetails';
import { ServerResponseType, CreateVehicleResponseType } from './types';

export const transformCreateVehicleResponse = (
  response: ServerResponseType
): CreateVehicleResponseType => {
  return {
    id: response.identifier,
    appDetails: transformAppDetails(response),
  };
};
